// extracted by mini-css-extract-plugin
module.exports = {"othersInput":"CheckBoxGroup_othersInput_2OHDt","checkboxGroup":"CheckBoxGroup_checkboxGroup_3oGys"};